import PropertyDealFinder from './property-finder';

export default PropertyDealFinder;
